import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Typography,
  Timeline,
  Row,
  Col,
  Modal,
  message,
  Spin,
  Dropdown,
  Menu,
} from "antd";
import AdminDashboard from "../Layout/AdminDashboard";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import dayjs from "dayjs";
import { useAuth } from "../Context/AuthContext";
import { useLocation } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import ChecklistModal from "../Layout/ChecklistModal";
import CurrentStepModal from "../Layout/CurrentStepModal";
import { set } from "lodash";

const { Title, Text } = Typography;

const AuditForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [modalAction, setModalAction] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [auditData, setAuditData] = useState({});
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [comment, setComment] = useState(""); // State to capture comments
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [intialLoading, setIntialLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentStepModalVisible, setCurrentStepModalVisible] = useState(false);
  const [service, setService] = useState("");
  const [serviceTPA, setServiceTPA] = useState(false);
  const [vertical_of_industry, setVerticalOfIndustry] = useState("");

  const location = useLocation();
  const { user } = useAuth();
  console.log("This is the user", serviceTPA);
  const showModal = (service, vertical_of_industry) => {
    setVerticalOfIndustry(vertical_of_industry);
    setService(service);
    setModalVisible(true);

  };
  const closeModal = () => setModalVisible(false);

  const openCurrentStepModal = () => setCurrentStepModalVisible(true);
  const closeCurrentStepModal = () => setCurrentStepModalVisible(false);

  const getStatusColor = (status) => {
    switch (status) {
      case "assigned":
        return "bg-yellow-100 text-yellow-800 rounded-full";
      case "submitted":
        return "bg-green-100 text-green-800 rounded-full";
      case "approved":
        return "bg-green-100 text-green-800 rounded-full";
      case "draft":
        return "bg-yellow-100 text-yellow-800 rounded-full";
      case "modified":
        return "bg-red-100 text-red-800 rounded-full";
      case "in-progress":
        return "bg-blue-100 text-blue-800 rounded-full";
      default:
        return "bg-green-100 text-green-800 rounded-full";
    }
  };

  useEffect(() => {
    // Scroll to the top of the page whenever this component is rendered
    window.scrollTo(0, 0);
  }, []);

  const handleDownload = async () => {
    setLoading(true); // Start loading
    try {
      const payload = {
        audit_id: params.audit_id,
        checkListId: auditData.checkListId._id,
      };

      console.log("This is the payload", payload);

      // Use `POST` to send the payload as the request body
      const response = await axios.post(
        `${apiUrl}/api/auditor/generateAuditReport`,
        payload,
        {
          responseType: "blob", // Specify the response is a file (PDF)
        }
      );

      console.log("This is the response");

      // Create a Blob from the PDF Stream
      const file = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);

      // Set the file name for the download
      link.download = "audit-report.pdf";

      // Append the link to the body and trigger a click event to download the file
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the audit report:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleModalOk = async () => {
    if (modalAction === "modified" && !comment.trim()) {
      message.warning("Please enter a comment before modifying."); // optional
      return;
    }
    try {
      const status = modalAction === "approve" ? "approved" : "modified";
      const payload = {
        status,
        userId: user._id, // Replace with actual user ID
      };

      // Include the comment if the action is "reject"
      if (status === "modified") {
        payload.comment = comment;
      }

      const response = await axios.put(
        `${apiUrl}/api/auditor/updateStatusHistoryByAuditId/${params.audit_id}`,
        payload
      );

      if (response.data.success) {
        message.success(
          `${modalAction.charAt(0).toUpperCase() + modalAction.slice(1)
          } successfully!`
        );
        setApprovalModalVisible(false);
        setComment(""); // Clear comment after submission
        fetchAudit(); // Refresh data
        navigate("/submittedForApproval");
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error("Failed to update the status.");
    }
  };

  const handleModalCancel = () => {
    setApprovalModalVisible(false);
    setComment(""); // Reset comment on cancel
  };

  const handleStatusUpdate = async () => {
    try {
      const response = await axios.put(
        `${apiUrl}/api/auditor/updateStatusHistoryByAuditId/${params.audit_id}`,
        {
          status: "submitted",
        }
      );

      if (response.status === 200) {
        console.log("Status updated successfully:", response.data);
        message.success("Submitted sucessfully!");
        navigate("/draft");
        // Optionally, add any additional actions here, such as updating the UI or notifying the user
      } else {
        console.error("Failed to update status. Response:", response);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const showApprovalModal = (action) => {
    setModalAction(action);
    setApprovalModalVisible(true);
  };

  const fetchAudit = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/auditor/getAuditById/${params.audit_id}`
      );
      if (response.data.success) {
        setAuditData(response.data.data);
        console.log("responce data", response.data.data.service);

        setServiceTPA(response.data.data.service === "TPA");

        console.log("This is the audit data", auditData);
        form.setFieldsValue(response.data.data); // Populate form fields
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error("Failed to fetch audit details.");
    } finally {
      setIntialLoading(false); // Reset the loading state here
    }
  };

  useEffect(() => {
    fetchAudit();
  }, [params.audit_id, form]);



  const onFinish = async (values) => {
    const payload = {
      ...values,
      assigned_date: values.assigned_date
        ? dayjs(values.assigned_date).format("YYYY-MM-DD")
        : null,
      physical_date: values.physical_date
        ? dayjs(values.physical_date).format("YYYY-MM-DD")
        : null,
    };

    console.log("Payload sent to backend:", payload);
    console.log("Form values to be submitted:", values);
    try {
      const response = await axios.put(
        `${apiUrl}/api/auditor/updateAuditById/${params.audit_id}`,
        payload
      );
      if (response.data.success) {
        message.success("Audit updated successfully!");
        setIsEditable(false);
        fetchAudit();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error("Failed to update audit.");
    }
  };

  const handleApproveButton = () => {
    showApprovalModal("approve");
  };

  const handleModifyButton = () => {
    showApprovalModal("modified");
  };

  // Split the pathname by '/' and filter out any empty strings
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Extract the first segment, which will be the first meaningful part
  const firstSegment = pathSegments[0];

  // console.log("this is the first segment", firstSegment);

  // const handleViewAndModify = () => {
  //   // Get the first segment of the current pathname
  //   const firstSegment = location.pathname.split("/").filter(Boolean)[0]; // 'draft', 'assigned-audit', etc.
  //   if (
  //     !auditData.checkListId ||
  //     !auditData.checkListId._id ||
  //     !auditData.checkListId.name
  //   ) {
  //     message.error("Checklist data is not available for this audit.");
  //     return;
  //   }
  //   // Determine the target path based on the first segment
  //   const targetPath =
  //     firstSegment === "assigned-audit"
  //       ? `/${firstSegment}/audit-report/${params.audit_id}?&checklistId=${auditData.checkListId._id}&category=${auditData.checkListId.name}`
  //       : `/${firstSegment}/audit-form/updateAuditReport/${params.audit_id}?&checklistId=${auditData.checkListId._id}&category=${auditData.checkListId.name}`;

  //   // Navigate to the target path
  //   navigate(targetPath);
  // };

  const handleViewAndModify = () => {
    // Check condition for opening CurrentStepModal instead of navigation
    const firstSegment = location.pathname.split("/").filter(Boolean)[0]; // 'draft', 'assigned-audit', etc.

    if (
      !auditData.checkListId ||
      !auditData.checkListId._id ||
      !auditData.checkListId.name
    ) {
      openCurrentStepModal();
      return;
    }

    // Existing navigation logic
    // const firstSegment = location.pathname.split("/").filter(Boolean)[0]; // 'draft', 'assigned-audit', etc.

    if (
      !auditData.checkListId ||
      !auditData.checkListId._id ||
      !auditData.checkListId.name
    ) {
      message.error("Checklist data is not available for this audit.");
      return;
    }

    const targetPath =
      firstSegment === "assigned-audit"
        ? `/${firstSegment}/audit-report/${params.audit_id}?&checklistId=${auditData.checkListId._id}&category=${auditData.checkListId.name}`
        : `/${firstSegment}/audit-form/updateAuditReport/${params.audit_id}?&checklistId=${auditData.checkListId._id}&category=${auditData.checkListId.name}`;

    navigate(targetPath);
  };


  const handleEditButton = () => {
    setIsEditable(true);
  };

  const handleSubmitButton = () => {
    form.submit();
    console.log("Form submitted"); // Trigger form submission
  };

  //check if checklist is not in assigned  route
  const isCheckListAssignedRoute = firstSegment === "assigned-audit";

  const isServiceHygieneRatingTPA =
    auditData.service === "Hygiene Rating" || auditData.service === "TPA";

  //Hiding and showing
  const isApprovedOrSubmitted =
    firstSegment === "approved" || firstSegment === "submittedForApproval";

  const isDraftSubmit =
    firstSegment === "draft" ||
    (firstSegment === "modified" && user?.role === "AUDITOR");

  const shouldRenderViewModifyButton =
    firstSegment === "draft" ||
    firstSegment === "modified" ||
    firstSegment === "assigned-audit";

  const isHygieneAndTpa =
    auditData.service === "Hygiene Rating" || auditData.service === "TPA";

  const isNotHygieneAndTpa =
    auditData.service !== "Hygiene Rating" &&
    auditData.service != "TPA" &&
    firstSegment === "assigned-audit" &&
    user?.role === "AUDITOR";

  const isViewModifyButtonDisabled = firstSegment === "assigned-audit";

  const viewModifyButtonStyles = {
    backgroundColor: isViewModifyButtonDisabled ? "#d9d9d9" : "#009688",
    borderColor: isViewModifyButtonDisabled ? "#d9d9d9" : "#009688",
    color: isViewModifyButtonDisabled ? "#8c8c8c" : "#fff",
  };

  const isUserAuditor = user?.role === "AUDITOR";

  const isUserAuditAdmin =
    user?.role === "AUDIT_ADMIN" || user?.role === "SUPER_ADMIN";

  // Check if the user role is 'Auditor' and firstSegment is 'assigned_audit'
  const shouldShowStartAuditButton =
    isUserAuditor && firstSegment === "assigned-audit";

  const handleMenuClick = async (e) => {
    if (e.key === "edit") {
      handleEditButton(); // Call your edit function here
    } else if (e.key === "delete") {
      // Show confirmation modal
      Modal.confirm({
        title: "Are you sure you want to delete this audit?",
        content: "This action cannot be undone.",
        okText: "Yes",
        cancelText: "No",
        onOk: async () => {
          try {
            // Make Axios delete request
            await axios.delete(
              `${apiUrl}/api/auditor/deleteAuditById/${params.audit_id}`
            );
            message.success("Audit deleted successfully!");
            navigate(-1); // Navigate back after delete
          } catch (error) {
            console.error("Error deleting audit:", error);
            message.error("Failed to delete audit. Please try again.");
          }
        },
        onCancel: () => {
          console.log("Delete action cancelled");
        },
      });
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="edit">
        Edit
      </Menu.Item>
      <Menu.Item disabled={!isUserAuditAdmin} key="delete">
        Delete
      </Menu.Item>
    </Menu>
  );

  const handleAuditCancel = () => {
    // Toggle the isEditable state
    setIsEditable((prevState) => !prevState);
    console.log("Editable state toggled:", !isEditable);
  };

  return (
    <AdminDashboard>
      <Spin spinning={intialLoading}>
        <div
          style={{
            padding: "24px",
            backgroundColor: "#f6f9fc",
            minHeight: "100vh",
          }}
        >
          <Row gutter={16} justify="center">
            <Col xs={24} md={16} lg={12}>
              <div className="flex items-center p-5 justify-between">
                <div className="flex-1 text-center">
                  <h4 className="text-xl font-medium">Audit Information</h4>
                </div>
                <div>
                  <Button
                    style={{ padding: 4, marginBottom: 16 }}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Button>
                </div>
              </div>

              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div style={{ textAlign: "right" }}>
                  <div className="flex justify-end">
                    <div>
                      {!isEditable ? (
                        "" // Show nothing when not editable
                      ) : (
                        <div className="flex">
                          {/* Save Button - Primary Color */}
                          <Button
                            type="primary" // Makes the Save button primary (blue)
                            style={{ padding: 4, marginBottom: 16 }}
                            onClick={handleSubmitButton}
                          >
                            Save
                          </Button>

                          {/* Cancel Button - White color with border */}
                          <div className="ml-4">
                            <Button
                              type="default" // Makes the Cancel button white with border
                              style={{ padding: 4, marginBottom: 16 }}
                              onClick={handleAuditCancel}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <Dropdown overlay={menu} trigger={["click"]}>
                        <Button type="link" icon={<MoreOutlined />} />
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="FBO Name"
                      name="fbo_name"
                      rules={[
                        { required: true, message: "Please enter FBO Name!" },
                      ]}
                    >
                      <Input
                        placeholder="Name comes here"
                        disabled={!isEditable}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Outlet Name"
                      name="outlet_name"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Outlet Name!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Name comes here"
                        disabled={!isEditable}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Proposal Number"
                      name="proposal_number"
                      rules={[
                        {
                          required: true,
                          message: "Proposal Number is required!",
                        },
                      ]}
                    >
                      <Input placeholder="#PROP 0001" disabled />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Location"
                      name="location"
                      rules={[
                        { required: true, message: "Please enter Location!" },
                      ]}
                    >
                      <Input placeholder="Porur" disabled={!isEditable} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Audit Number"
                      name="audit_number"
                      rules={[
                        {
                          required: true,
                          message: "Audit Number is required!",
                        },
                      ]}
                    >
                      <Input placeholder="02" disabled />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Service"
                      name="service"
                      rules={[
                        { required: true, message: "Service is required!" },
                      ]}
                    >
                      <Input placeholder="02" disabled />
                    </Form.Item>
                  </Col>

                  {!isCheckListAssignedRoute && isServiceHygieneRatingTPA && (
                    <Col span={12}>
                      <Form.Item label="Checklist Category">
                        <Input
                          value={auditData.checkListId?.name || "N/A"}
                          placeholder="02"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={12}>
                    <Form.Item
                      label="Audit Date"
                      name="assigned_date"
                      getValueProps={(i) => ({ value: dayjs(i) })}
                      rules={[
                        {
                          required: true,
                          message: "Please select the Audit Date!",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        placeholder="Select date"
                        format="DD-MM-YYYY"
                        allowClear={false}
                        disabled={!isEditable}
                      />
                    </Form.Item>
                  </Col>

                  {auditData.physical_date && (
                    <Col span={12}>
                      <Form.Item
                        label="Physical Date"
                        name="physical_date"
                        getValueProps={(i) => ({ value: dayjs(i) })}
                        rules={[
                          {
                            required: true,
                            message: "Please select the Physical Date!",
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          placeholder="Select date"
                          format="DD-MM-YYYY"
                          disabled={!isEditable}
                          allowClear={false}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {isHygieneAndTpa && (
                    <Col span={12}>
                      <Form.Item
                        label="Vertical of Industry"
                        name="vertical_of_industry"
                        rules={[
                          {
                            required: true,
                            message: "Please select the Vertical of Industry!",
                          },
                        ]}
                      >
                        <Input
                          value={auditData.vertical_of_industry || "N/A"}
                          placeholder="02"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginTop: "24px",
                  }}
                >
                  {isApprovedOrSubmitted && isHygieneAndTpa && (
                    <>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#009688",
                          borderColor: "#009688",
                          color: "#fff",
                        }}
                        onClick={handleViewAndModify}
                      >
                        View
                      </Button>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#009688",
                          borderColor: "#009688",
                          color: "#fff",
                        }}
                        onClick={handleDownload}
                        loading={loading}
                        disabled={loading}
                      >
                        Download Report
                      </Button>
                    </>
                  )}

                  {shouldShowStartAuditButton && isHygieneAndTpa && (
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#009688",
                        borderColor: "#009688",
                      }}
                      // onClick={handleStartedDate}
                      onClick={() =>
                        showModal(
                          auditData.service,
                          auditData.vertical_of_industry,
                          // serviceTPA
                        )
                      }
                    >
                      Start Audit
                    </Button>
                  )}

                  {isNotHygieneAndTpa && ( // Hide the button for 'Hygiene Rating' and 'TPA' services
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#009688",
                        borderColor: "#009688",
                      }}
                      onClick={openCurrentStepModal}
                    >
                      Update Status
                    </Button>
                  )}
                  {shouldRenderViewModifyButton && (
                    <Button
                      type="primary"
                      style={viewModifyButtonStyles}
                      onClick={
                        !isViewModifyButtonDisabled
                          ? handleViewAndModify
                          : undefined
                      }
                      disabled={isViewModifyButtonDisabled}
                    >
                      View/Modify
                    </Button>
                  )}
                  {isDraftSubmit && (
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#009688",
                        borderColor: "#009688",
                        color: "#fff",
                      }}
                      onClick={handleStatusUpdate}
                    >
                      Submit
                    </Button>
                  )}

                  {user?.role &&
                    firstSegment === "submittedForApproval" &&
                    (user.role === "SUPER_ADMIN" ||
                      user.role === "AUDIT_ADMIN") && (
                      <>
                        <Button
                          type="primary"
                          style={{
                            backgroundColor: "#009688",
                            borderColor: "#009688",
                            color: "#fff",
                          }}
                          onClick={handleApproveButton}
                        >
                          Approve
                        </Button>
                        <Button
                          type="primary"
                          style={{
                            backgroundColor: "#009688",
                            borderColor: "#009688",
                            color: "#fff",
                          }}
                          onClick={handleModifyButton}
                        >
                          Modify
                        </Button>
                      </>
                    )}
                </div>
              </Form>
            </Col>
            <Col xs={30} md={8} lg={6}>
              <div className="border mt-5">
                <div className="border p-4 bg-white">
                  <Title level={4} style={{ textAlign: "center" }}>
                    Current Status
                  </Title>
                </div>
                <div
                  style={{
                    maxHeight: "500px", // Adjust container height
                    overflowY: "auto", // Enable vertical scrolling
                    padding: "20px",
                    backgroundColor: "#f6f9fc",
                    borderRadius: "8px",
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#888 #f6f9fc", // Custom scrollbar for Firefox
                  }}
                >
                  <Timeline
                    style={{
                      padding: "24px",
                      backgroundColor: "#f6f9fc",
                      borderRadius: "8px",
                    }}
                    items={[
                      {
                        color: "orange",
                        children: (
                          <>
                            <span
                              className={`px-2 py-1 text-sm font-semibold rounded ${getStatusColor(
                                "assigned"
                              )}`}
                            >
                              Assigned
                            </span>
                            <br />
                            <Text type="secondary">
                              {auditData.assigned_date
                                ? moment(auditData.assigned_date).format(
                                  "DD/MM/YYYY HH:mm"
                                )
                                : "N/A"}
                            </Text>
                            <br />
                            <Text type="secondary">
                              {auditData?.status_changed_at}
                            </Text>
                          </>
                        ),
                      },

                      ...(auditData?.started_at
                        ? [
                          {
                            color: "blue",
                            children: (
                              <>
                                <span
                                  className={`px-2 py-1 text-sm font-semibold rounded ${getStatusColor(
                                    "in-progress"
                                  )}`}
                                >
                                  Started
                                </span>
                                <br />
                                <Text type="secondary">
                                  {moment(auditData.started_at).format(
                                    "DD/MM/YYYY HH:mm"
                                  )}
                                </Text>
                              </>
                            ),
                          },
                        ]
                        : []),

                      // ...(auditData?.modificationHistory?.length > 0
                      //   ? auditData.modificationHistory.map(
                      //     (modification, index) => ({
                      //       color: "blue",
                      //       children: (
                      //         <div key={index}>
                      //           <span
                      //             className={`px-2 py-1 text-sm font-semibold rounded ${getStatusColor(
                      //               "in-progress"
                      //             )}`}
                      //           >
                      //             Last Edited
                      //           </span>
                      //           <br />
                      //           <Text type="secondary">
                      //             {moment(modification?.modifiedAt).format(
                      //               "DD-MM-YYYY"
                      //             )}{" "}
                      //             {moment(modification?.modifiedAt).format(
                      //               "HH:mm"
                      //             )}
                      //           </Text>
                      //           <br />
                      //         </div>
                      //       ),
                      //     })
                      //   )
                      //   : []),

                      ...(auditData?.statusHistory?.length > 0
                        ? auditData.statusHistory.map(
                          (statusHistory, index) => ({
                            color: "Green",
                            children: (
                              <div key={index}>
                                <span
                                  className={`px-2 py-1 text-sm font-semibold rounded ${getStatusColor(
                                    statusHistory.status
                                  )}`}
                                >
                                  {statusHistory.status
                                    .charAt(0)
                                    .toUpperCase() +
                                    statusHistory.status.slice(1)}
                                </span>

                                <br />
                                <Text type="secondary">
                                  {moment(statusHistory?.changedAt).format(
                                    "DD-MM-YYYY HH:mm"
                                  )}
                                </Text>
                                <br />
                                {/* Conditional rendering based on 'rejected' or 'approved' status */}
                                {statusHistory.status === "modified" ||
                                  statusHistory.status === "approved" ? (
                                  <>
                                    <Text className="font-medium">
                                      {statusHistory.userName}
                                    </Text>
                                    <br />
                                    {/* Show comment only for rejected status */}
                                    {statusHistory.status === "modified" && (
                                      <Text className="font-medium text-red-600">
                                        {statusHistory.comment}
                                      </Text>
                                    )}
                                    <br />
                                  </>
                                ) : null}
                              </div>
                            ),
                          })
                        )
                        : []),
                    ]}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Modal
            visible={approvalModalVisible}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            footer={null} // Custom footer implementation
            centered // Center the modal vertically
            className="w-full sm:w-96"
          >
            {/* Modal Title */}
            <div className="text-center pb-4 border-b border-gray-200">
              <h2 className="text-lg font-medium text-black">
                {modalAction === "approve"
                  ? "Approve Audit"
                  : "Enter Modification Reason"}
              </h2>
            </div>

            {/* Rejection Form (conditional) */}
            {modalAction === "modified" && (
              <Form.Item
                rules={[
                  { required: true, message: "Please provide a comment." },
                  { max: 100, message: "Comment cannot exceed 100 characters." },
                  {
                    validator: (_, value) =>
                      !value || value.trim().length === 0
                        ? Promise.reject("Comment cannot be empty")
                        : Promise.resolve(),
                  },
                ]}
                className="mt-4"
              >
                <Input.TextArea
                  value={comment}
                  maxLength={100}
                  onChange={(e) => {
                    if (e.target.value.length <= 100) setComment(e.target.value);
                  }}
                  placeholder="Enter your comment here..."
                  rows={4}

                />
                <div className="text-right text-sm text-gray-400 mt-1">
                  {comment.length}/100
                </div>
              </Form.Item>
            )}

            {/* Confirmation Message */}
            <p className="text-center text-gray-600 mt-4">
              Are you sure you want to{" "}
              <span className="font-semibold text-black">
                {modalAction === "approve" ? "approve" : "modify"}
              </span>{" "}
              this audit?
            </p>

            {/* Action Buttons */}
            <div className="flex justify-end gap-4 mt-6">
              {/* Cancel Button */}
              <Button onClick={handleModalCancel}>Cancel</Button>

              {/* Approve/Reject Button */}
              <Button
                type="primary"
                onClick={handleModalOk}
                danger={modalAction === "modify"} // Use Ant Design's "danger" style for rejection
              >
                {modalAction === "approve" ? "Approve" : "Modify"}
              </Button>
            </div>
          </Modal>
          <ChecklistModal
            visible={modalVisible}
            service={service}
            vertical_of_industry={vertical_of_industry}
            onClose={closeModal}
          />
          <CurrentStepModal
            visible={currentStepModalVisible}
            onClose={closeCurrentStepModal}
            reload={fetchAudit}
          />
        </div>
      </Spin>
    </AdminDashboard>
  );
};

export default AuditForm;
